module.exports = __webpack_public_path__ + "img/杨建华.26e1f5fb.png";